export default "__VITE_ASSET__AQkCn6Jv__"